import {
    Bar,
    BarChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";
import Typography from "./Typography";

type KeyItem<T> = {
    name: Exclude<keyof T, "label">;
    colour: string;
};

type DataItem<T> = {
    label: string;
} & T;

type StackedBarChartProps<T> = {
    ticks?: number[];
    keys: KeyItem<T>[];
    data: DataItem<T>[];
};

const StackedBarChart = <T,>({
    ticks,
    keys,
    data,
}: StackedBarChartProps<T>) => {
    return (
        <div className="w-full mt-12 mb-9">
            <div className="flex items-center gap-6 mb-7 pl-4">
                {keys.map((key) => (
                    <div
                        className="flex-none flex items-center gap-3"
                        key={key.name.toString()}
                    >
                        <div
                            className="w-3 h-3"
                            style={{ backgroundColor: key.colour }}
                        />
                        <Typography variant="label-medium" component="p">
                            {key.name.toString()}
                        </Typography>
                    </div>
                ))}
            </div>
            <div className="h-[208px]">
                <ResponsiveContainer>
                    <BarChart
                        data={data}
                        margin={{
                            top: 0,
                            right: 0,
                            left: -20,
                            bottom: 0,
                        }}
                    >
                        <CartesianGrid stroke="#E1E7DC" />
                        <XAxis
                            dataKey="label"
                            tickLine={false}
                            tick={{
                                fontSize: "0.75rem",
                                fill: "#191C1D",
                                fontWeight: 600,
                            }}
                            style={{
                                fontFamily: "Roboto",
                            }}
                            stroke="#E1E7DC"
                        />
                        <YAxis
                            ticks={ticks}
                            tickLine={false}
                            tick={{
                                fontSize: "0.75rem",
                                fill: "#191C1D",
                                fontWeight: 600,
                            }}
                            style={{
                                fontFamily: "Roboto",
                            }}
                            strokeOpacity={0}
                        />
                        <Tooltip />
                        {keys.map((key) => (
                            <Bar
                                key={`chart-bar-${key.name.toString()}`}
                                dataKey={key.name.toString()}
                                stackId="a"
                                fill={key.colour}
                                barSize={12}
                            />
                        ))}
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default StackedBarChart;
